// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__2YkzK","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__3bjFQ"};